module.exports = __webpack_public_path__ + "static/media/security-system.ca5c8b23.png";